import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Chift\DeleteCompanyConsumerController::__invoke
* @see app/Http/Controllers/Chift/DeleteCompanyConsumerController.php
* @route '/api/company/{company}/chift/consumer'
*/
const DeleteCompanyConsumerController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCompanyConsumerController.url(args, options),
    method: 'delete',
})

DeleteCompanyConsumerController.definition = {
    methods: ["delete"],
    url: '/api/company/{company}/chift/consumer',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Chift\DeleteCompanyConsumerController::__invoke
* @see app/Http/Controllers/Chift/DeleteCompanyConsumerController.php
* @route '/api/company/{company}/chift/consumer'
*/
DeleteCompanyConsumerController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return DeleteCompanyConsumerController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Chift\DeleteCompanyConsumerController::__invoke
* @see app/Http/Controllers/Chift/DeleteCompanyConsumerController.php
* @route '/api/company/{company}/chift/consumer'
*/
DeleteCompanyConsumerController.delete = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCompanyConsumerController.url(args, options),
    method: 'delete',
})

export default DeleteCompanyConsumerController